import React from 'react'
import DateComp from '../../../../../core/common/dateComponent/DateComp'
import { svgIcons } from '../../../../../style/fonts/SvgIcons'
import { Link } from 'react-router-dom'
import dayjs from "dayjs"
import FormattedNumber from '../../../../../core/common/textFields/FormatNumber'
const NotesAddenda = ({ comment, setComment, formik, viewOnly, isReviewed, }: any) => {

  const formattedDate = dayjs().format("YYYY-MM-DD_HH-mm-ss");

  const decodeHtml = (html: any) => {
    const txt = document.createElement("textarea");
    txt.innerHTML = html;
    return txt.value;
  }
  return (
    <div className='row  mt-2'>
      <div className='col-md-12 '>
        <label className='mb-2'>Comments</label>
        <textarea
          className='form-control'
          rows={5}
          style={{ width: '100%' }}
          value={formik?.values?.comment}
          onChange={(e: any) => {
            setComment(e.target?.value)
            formik.setFieldValue('comment', e.target?.value)
          }}
          disabled={viewOnly}
        />
      </div>
      <div className='col-md-12 mt-2'>
        {
          formik?.values?.comments?.map((item: any, index: any) => (
            <div key={item.id}>
              <Link
                to="#"
                className="task-accordion"
                data-bs-toggle="collapse"
                data-bs-target={`#${item.id}`}
                onClick={(e) => e.preventDefault()}
              >
                <div className="noti-content mt-3">
                  <ul className="notification-list">
                    <li className="notification-message">
                      <Link to="#" onClick={(e) => e.preventDefault()}>
                        <div className="d-flex gap-2 align-items-center">
                          <h6 className="">
                            <span className="mb-0 icon-style me-2">{svgIcons.NotesIcon}</span>
                          </h6>
                          <div className="task-info">
                            <p className={`mb-0 `}>
                              <h6>{item.title}</h6>
                            </p>
                            <p className={`mb-0 `}>
                              <h6 className="text-muted">created by</h6>
                            </p>
                            <p className={`mb-0 `}>
                              <h6>{item.lst_CreatedBy?.value || ''}</h6>
                            </p>
                            <p className={`mb-0 `}>
                              <h6 className="text-muted">at</h6>
                            </p>
                            <p className={`mb-0 `}>
                              <h6>{item.createdDT ? dayjs(item.createdDT).format("MMM-DD-YYYY HH:mm:ss A") : null}</h6>
                            </p>
                          </div>
                        </div>
                      </Link>
                    </li>
                  </ul>
                </div>
              </Link>
              <div className="tasks-activity tasks collapse show" key={item.id} id={item.id}>
                <ul>
                  {/* <li className='px-5'>
                    <p className={`noti-details mb-0 `}>
                      Addenda Nbr: {formik.values?.addendaNbr}
                    </p>

                    {((item.status === "Approved" && formik.values?.addendaType?.id === 6) || (item.status === "Reviewed" && formik.values?.addendaType?.id !== 6)) &&
                      <>
                        <p className={`noti-details mb-0 `}>
                          Written By: {item?.writtenBy}
                        </p>
                        <p className={`noti-details mb-0 `}>
                          Addenda Date: {formik.values?.addendaDate ? dayjs(formik.values?.addendaDate).format("MMM-DD-YYYY") : null}
                        </p>
                        <p className={`noti-details mb-0 `}>
                          Type: {item?.type}
                        </p>
                        <p className={`noti-details mb-0 `}>
                          Addenda Sale Amt: <FormattedNumber value={item?.saleAmount} />
                        </p>
                        <p className={`noti-details mb-0 `}>
                          Addenda Cost Amt:   <FormattedNumber value={item?.costAmount} />
                        </p>
                        <p className={`noti-details mb-0 `}>
                          Markup: {formik.values?.addendaMarkUp.toFixed(2)}
                        </p>
                        <p className={`noti-details mb-0 `}>
                          Amount Paybale Upon Acceptance: <FormattedNumber value={item?.amountPayableUponAcceptance} />
                        </p>
                        <p className={`noti-details mb-0 `}>
                          Contract Language Impacted: {item?.contractLanguage === false ? "No" : "Yes"}
                        </p>
                        <p className={`noti-details mb-0`}>
                          Timeline Impacted: {item?.timelineImpacted === null ? 'No' : item?.timelineImpacted === false ? "No" : "Yes"}
                        </p>
                        <p className={`noti-details mb-0`}>
                          Internal Timeline Impacted: {item?.internalTimelineImpact}
                        </p>
                        <p className={`noti-details mb-0`}>
                          External Timeline Impacted: {item?.externalTimelineImpact}
                        </p>
                        <p className={`noti-details mb-0`}>
                          Phase Most Affected:
                          {formik.values.timeLineIsFieldProduction === true ? formik.values.lst_SubstantialComplete.value : formik.values.lst_ContractReview.value
                          }
                        </p>
                        <p className={`noti-details mb-0`}>
                          Description: {item?.description}
                        </p>
                        <p className={`noti-details mb-0`}>
                          Internal Description: {item?.internalDescription}
                        </p>
                      </>
                    }
                    <p className={`noti-details mb-0 `}>
                      Addenda Status: {item?.status}
                    </p>
                    {item.comment !== null && item.comment !== "" &&
                      <p className={`noti-details mb-0`}
                        style={{ whiteSpace: 'pre-wrap' }}

                      >
                        {item.title !== "Action Note" ?
                          "Comment :" : ""}
                        <br />
                        <span dangerouslySetInnerHTML={{ __html: decodeHtml(item.comment) }} />

                      </p>
                    }
                  </li> */}
                  <li className='px-5'>
                    <p
                      dangerouslySetInnerHTML={{
                        __html: decodeHtml(item.description)?.replace(/\n/g, "<br/>"),
                      }}
                    />
                  </li>
                </ul>
              </div>
              <hr />
            </div>
          ))
        }
      </div>
    </div>
  )
}

export default NotesAddenda